module.exports = __webpack_public_path__ + "img/pic-three.3d52f36e.png";